import React from "react";
import { useI18n } from "@/context/I18nContext";

export const SUPPORT_STATUS_TONE = {
  neu: "border-[#A3E635]/40 bg-[#A3E635]/10 text-[#A3E635]",
  in_bearbeitung: "border-blue-400/40 bg-blue-400/10 text-blue-300",
  warten_auf_kunde: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  warten_auf_kewag: "border-violet-400/40 bg-violet-400/10 text-violet-300",
  loesung_vorgeschlagen: "border-teal-400/40 bg-teal-400/10 text-teal-300",
  erledigt: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  archiviert: "border-white/15 bg-white/5 text-gray-400",
};

export const PRIORITIES = [["kritisch", "Kritisch"], ["hoch", "Hoch"], ["mittel", "Mittel"], ["niedrig", "Niedrig"]];
export const PRIO_TONE = {
  kritisch: "text-red-200 bg-red-500/20 border-red-500/50",
  hoch: "text-red-300 bg-red-400/10 border-red-400/30",
  mittel: "text-amber-200/90 bg-amber-400/10 border-amber-400/20",
  niedrig: "text-gray-400 bg-white/5 border-white/10",
};
export const SLA_TONE = {
  ueberfaellig: "text-red-300 bg-red-500/15 border-red-500/40",
  bald_faellig: "text-amber-300 bg-amber-400/10 border-amber-400/30",
  im_zeitplan: "text-emerald-300 bg-emerald-400/10 border-emerald-400/30",
  wartet_kunde: "text-gray-400 bg-white/5 border-white/10",
  kein: "text-gray-500 bg-white/5 border-white/10",
};

export const StatusPill = ({ status, label, testid }) => (
  <span data-testid={testid} className={`text-[11px] px-2.5 py-1 rounded-full border font-semibold whitespace-nowrap ${SUPPORT_STATUS_TONE[status] || SUPPORT_STATUS_TONE.archiviert}`}>
    {label || status}
  </span>
);

export const PrioPill = ({ p, label }) => (
  <span className={`text-[10px] px-2 py-0.5 rounded-full border font-bold uppercase tracking-wide ${PRIO_TONE[p] || PRIO_TONE.mittel}`}>{label || p || "mittel"}</span>
);

export const CatPill = ({ label }) => (
  <span className="text-[10px] px-2 py-0.5 rounded-full border border-white/10 bg-white/5 text-gray-300 font-semibold whitespace-nowrap">{label}</span>
);

export const KundeAmZug = ({ testid }) => {
  const { t } = useI18n();
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full border border-amber-400/40 bg-amber-400/10 text-amber-300 whitespace-nowrap">
      {t("Kunde am Zug")}
    </span>
  );
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("de-CH", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "numeric" }); }
  catch { return iso; }
};

export const SlaPill = ({ state, label, testid }) => {
  if (!state || state === "kein") return null;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full border font-bold whitespace-nowrap ${SLA_TONE[state] || SLA_TONE.kein}`}>
      {label || state}
    </span>
  );
};

export const slaCountdown = (iso) => {
  if (!iso) return "";
  const ms = new Date(iso) - new Date();
  const abs = Math.abs(ms);
  const h = Math.floor(abs / 3600000);
  const m = Math.floor((abs % 3600000) / 60000);
  const txt = h >= 24 ? `${Math.floor(h / 24)} Tg ${h % 24} Std` : h >= 1 ? `${h} Std ${m} Min` : `${m} Min`;
  return ms < 0 ? `seit ${txt} überfällig` : `in ${txt} fällig`;
};

export const fmtSize = (b) => {
  if (b === null || b === undefined) return "";
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
  return `${(b / 1024 / 1024).toFixed(1)} MB`;
};

export const inputCls = "w-full bg-black border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#A3E635] transition-colors";
